
import { Button } from "@/components/ui/button";
import { FileText, Video } from "lucide-react";
import { Label } from "@/components/ui/label";

interface FileTypeSelectorProps {
  selectedType: string;
  onChange: (type: string) => void;
}

export function FileTypeSelector({ selectedType, onChange }: FileTypeSelectorProps) {
  return (
    <div>
      <Label>Τύπος Αρχείου</Label>
      <div className="grid grid-cols-2 gap-2 mt-1">
        <Button 
          variant={selectedType === 'document' ? 'default' : 'outline'} 
          onClick={() => onChange('document')}
          className="w-full justify-center"
        >
          <FileText className="h-4 w-4 mr-2" /> Έγγραφο
        </Button>
        <Button 
          variant={selectedType === 'video' ? 'default' : 'outline'} 
          onClick={() => onChange('video')}
          className="w-full justify-center"
        >
          <Video className="h-4 w-4 mr-2" /> Βίντεο
        </Button>
      </div>
    </div>
  );
}
